import { animate, style, transition, trigger } from '@angular/animations';

export const menuTransition = trigger('menuTransition', [
  transition('* => open', [
    style({ opacity: 0 }),
    animate('.12s ease-out', style({ opacity: 1 })),
  ]),
  transition('* => open-mobile', [
    style({ opacity: 0, transform: 'translateY(75%)' }),
    animate('.34s ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [style({ opacity: 1 }), animate('.12s', style({ opacity: 0 }))]),
]);
